/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DeleteNavigationCategory } from '../fn/navigation/delete-navigation-category';
import { DeleteNavigationCategory$Params } from '../fn/navigation/delete-navigation-category';
import { DeleteNavigationLink } from '../fn/navigation/delete-navigation-link';
import { DeleteNavigationLink$Params } from '../fn/navigation/delete-navigation-link';
import { GetNavigationCategory } from '../fn/navigation/get-navigation-category';
import { GetNavigationCategory$Params } from '../fn/navigation/get-navigation-category';
import { GetNavigationLink } from '../fn/navigation/get-navigation-link';
import { GetNavigationLink$Params } from '../fn/navigation/get-navigation-link';
import { ListNavigationCategories } from '../fn/navigation/list-navigation-categories';
import { ListNavigationCategories$Params } from '../fn/navigation/list-navigation-categories';
import { ListNavigationLinks } from '../fn/navigation/list-navigation-links';
import { ListNavigationLinks$Params } from '../fn/navigation/list-navigation-links';
import { NavigationCategoryModel } from '../models/navigation-category-model';
import { NavigationCategoryViewModelPrimeDatatableResults } from '../models/navigation-category-view-model-prime-datatable-results';
import { NavigationLinkModel } from '../models/navigation-link-model';
import { NavigationLinkViewModelPrimeDatatableResults } from '../models/navigation-link-view-model-prime-datatable-results';
import { SaveNavigationCategory } from '../fn/navigation/save-navigation-category';
import { SaveNavigationCategory$Params } from '../fn/navigation/save-navigation-category';
import { SaveNavigationLink } from '../fn/navigation/save-navigation-link';
import { SaveNavigationLink$Params } from '../fn/navigation/save-navigation-link';

@Injectable({ providedIn: 'root' })
export class NavigationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNavigationListNavigationLinksPost()` */
  static readonly ApiNavigationListNavigationLinksPostPath = '/api/Navigation/ListNavigationLinks';

  /**
   * List NavigationLink.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListNavigationLinks()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListNavigationLinks$Response(params?: ListNavigationLinks$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationLinkViewModelPrimeDatatableResults>> {
    return ListNavigationLinks(this.http, this.rootUrl, params, context);
  }

  /**
   * List NavigationLink.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListNavigationLinks$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListNavigationLinks(params?: ListNavigationLinks$Params, context?: HttpContext): Observable<NavigationLinkViewModelPrimeDatatableResults> {
    return this.ListNavigationLinks$Response(params, context).pipe(
      map((r: StrictHttpResponse<NavigationLinkViewModelPrimeDatatableResults>): NavigationLinkViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiNavigationGetNavigationLinkPost()` */
  static readonly ApiNavigationGetNavigationLinkPostPath = '/api/Navigation/GetNavigationLink';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetNavigationLink()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetNavigationLink$Response(params?: GetNavigationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationLinkModel>> {
    return GetNavigationLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetNavigationLink$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetNavigationLink(params?: GetNavigationLink$Params, context?: HttpContext): Observable<NavigationLinkModel> {
    return this.GetNavigationLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<NavigationLinkModel>): NavigationLinkModel => r.body)
    );
  }

  /** Path part for operation `apiNavigationSaveNavigationLinkPost()` */
  static readonly ApiNavigationSaveNavigationLinkPostPath = '/api/Navigation/SaveNavigationLink';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveNavigationLink()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveNavigationLink$Response(params?: SaveNavigationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationLinkModel>> {
    return SaveNavigationLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveNavigationLink$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveNavigationLink(params?: SaveNavigationLink$Params, context?: HttpContext): Observable<NavigationLinkModel> {
    return this.SaveNavigationLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<NavigationLinkModel>): NavigationLinkModel => r.body)
    );
  }

  /** Path part for operation `apiNavigationDeleteNavigationLinkPost()` */
  static readonly ApiNavigationDeleteNavigationLinkPostPath = '/api/Navigation/DeleteNavigationLink';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteNavigationLink()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DeleteNavigationLink$Response(params?: DeleteNavigationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteNavigationLink(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteNavigationLink$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DeleteNavigationLink(params?: DeleteNavigationLink$Params, context?: HttpContext): Observable<void> {
    return this.DeleteNavigationLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiNavigationListNavigationCategoriesPost()` */
  static readonly ApiNavigationListNavigationCategoriesPostPath = '/api/Navigation/ListNavigationCategories';

  /**
   * List NavigationCategory.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListNavigationCategories()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListNavigationCategories$Response(params?: ListNavigationCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationCategoryViewModelPrimeDatatableResults>> {
    return ListNavigationCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * List NavigationCategory.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListNavigationCategories$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListNavigationCategories(params?: ListNavigationCategories$Params, context?: HttpContext): Observable<NavigationCategoryViewModelPrimeDatatableResults> {
    return this.ListNavigationCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<NavigationCategoryViewModelPrimeDatatableResults>): NavigationCategoryViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiNavigationGetNavigationCategoryPost()` */
  static readonly ApiNavigationGetNavigationCategoryPostPath = '/api/Navigation/GetNavigationCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetNavigationCategory()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetNavigationCategory$Response(params?: GetNavigationCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationCategoryModel>> {
    return GetNavigationCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetNavigationCategory$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetNavigationCategory(params?: GetNavigationCategory$Params, context?: HttpContext): Observable<NavigationCategoryModel> {
    return this.GetNavigationCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<NavigationCategoryModel>): NavigationCategoryModel => r.body)
    );
  }

  /** Path part for operation `apiNavigationSaveNavigationCategoryPost()` */
  static readonly ApiNavigationSaveNavigationCategoryPostPath = '/api/Navigation/SaveNavigationCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveNavigationCategory()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveNavigationCategory$Response(params?: SaveNavigationCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationCategoryModel>> {
    return SaveNavigationCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveNavigationCategory$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveNavigationCategory(params?: SaveNavigationCategory$Params, context?: HttpContext): Observable<NavigationCategoryModel> {
    return this.SaveNavigationCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<NavigationCategoryModel>): NavigationCategoryModel => r.body)
    );
  }

  /** Path part for operation `apiNavigationDeleteNavigationCategoryPost()` */
  static readonly ApiNavigationDeleteNavigationCategoryPostPath = '/api/Navigation/DeleteNavigationCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteNavigationCategory()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DeleteNavigationCategory$Response(params?: DeleteNavigationCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return DeleteNavigationCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteNavigationCategory$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DeleteNavigationCategory(params?: DeleteNavigationCategory$Params, context?: HttpContext): Observable<void> {
    return this.DeleteNavigationCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
